import { connect, MapDispatchToProps } from "react-redux";
import { ISLPRequest, ISLPViewContainerDispatch } from "utils/interfaces/slp";
import {
  getAllSLPGoalsAndAssessmentRequest,
  getCompletedSLPDetailsRequest,
} from "store/studentProfileDetails/actions";
import {
  updateSLPParticipationRequest,
  viewSLPGoalsAssessmentPDFRequest,
} from "store/slpDashboard/actions";
import {
  addPersonalAndSmartGoalsRequest,
  deletePersonalAndSmartGoalsRequest,
} from "store/slpForm/action";
import SLPViewComponent, { SLPViewProps } from ".";

const mapDispatchToProps: MapDispatchToProps<
  ISLPViewContainerDispatch,
  ISLPRequest
> = {
  getCompletedSLPDetailsRequest,
  getAllSLPGoalsAndAssessmentRequest,
  viewSLPGoalsAssessmentPDFRequest,
  deletePersonalAndSmartGoalsRequest,
  addPersonalAndSmartGoalsRequest,
  updateSLPParticipationRequest,
};

const connector = connect(null, mapDispatchToProps);

const SLPView: React.FC<SLPViewProps> = (props) => {
  return <SLPViewComponent {...props} />;
};

export default connector(SLPView);
